/**
 * Thin wrappers around window.location for testability.
 * jsdom marks window.location as non-configurable, making it impossible
 * to mock directly. Importing these helpers lets tests jest.mock() them.
 */

export function navigateTo(url: string): void {
  window.location.href = url;
}

export function reloadPage(): void {
  window.location.reload();
}

export function replaceLocation(url: string): void {
  window.location.replace(url);
}
